export default "__VITE_ASSET__DMXDaj17__"